import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip, Box, Typography, Chip, Avatar } from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import { UserActionMenu } from "./UserActionMenu";
import { Icon } from "@iconify/react";
import personFill from "@iconify/icons-eva/person-fill";
import emailFill from "@iconify/icons-eva/email-fill";
import calendarFill from "@iconify/icons-eva/calendar-fill";
import editFill from "@iconify/icons-eva/edit-fill";

const dateFormat = "yyyy-MM-dd hh:mm a";

export const userListColumns = (isReadOnly) => [
  {
    field: "Actions",
    headerName: "",
    width: 50,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: ({ id, row }) => {
      return <UserActionMenu id={id} row={row} />;
    },
  },
  {
    field: "username",
    headerName: "User",
    flex: 2,
    minWidth: 200,
    renderCell: ({ value, row, id }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: 'primary.main',
            fontSize: '0.875rem',
            fontWeight: 600,
          }}
        >
          {value?.charAt(0)?.toUpperCase() || 'U'}
        </Avatar>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.primary' }}>
            {isReadOnly ? value : (
              <Link underline="none" component={RouterLink} to={`${id}`} sx={{ color: 'inherit' }}>
                {value}
              </Link>
            )}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {row.firstName} {row.lastName}
          </Typography>
        </Box>
        {!isReadOnly && (
          <Box
            sx={{
              opacity: 0.6,
              transition: 'opacity 0.2s ease',
              '&:hover': {
                opacity: 1,
              },
            }}
          >
            <Icon icon={editFill} width={16} height={16} color="text.secondary" />
          </Box>
        )}
      </Box>
    ),
  },
  {
    field: "email",
    headerName: "Email",
    flex: 2,
    minWidth: 250,
    renderCell: ({ value }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Icon icon={emailFill} width={16} height={16} color="#666" />
        <Tooltip title={value} placement="top">
          <Typography variant="body2" sx={{ 
            color: 'text.primary',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 200
          }}>
            {value}
          </Typography>
        </Tooltip>
      </Box>
    ),
  },
  {
    field: "createDate",
    headerName: "Created",
    flex: 1,
    minWidth: 150,
    renderCell: ({ value }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Icon icon={calendarFill} width={16} height={16} color="#666" />
        <Typography variant="body2" color="text.primary">
          {fDateTime(value, "MMM dd, yyyy")}
        </Typography>
      </Box>
    ),
  },
];

export const getUserDefaultValues = () => ({
  userId: "",
  username: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
});
